import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { ArrowLeft, XCircle } from "lucide-react";
import { PublicHeader } from "@/components/public-layout";

export const Route = createFileRoute("/upgrade-error")({
	head: () => ({
		meta: [{ name: "robots", content: "noindex, nofollow" }],
	}),
	component: UpgradeErrorPage,
});

function UpgradeErrorPage() {
	const navigate = useNavigate();

	return (
		<div className="min-h-svh bg-background">
			<PublicHeader />

			<main className="max-w-lg mx-auto px-4 py-16">
				<div className="border border-border bg-card p-6 sm:p-8">
					<div className="mx-auto mb-5 inline-flex size-10 items-center justify-center border border-[color:var(--ticker-down)]/40 bg-destructive/10">
						<XCircle className="size-4 text-[color:var(--ticker-down)]" />
					</div>

					<p className="font-mono text-sm uppercase tracking-[0.14em] text-muted-foreground">
						&gt; Error · upgrade
					</p>
					<h1
						className="mt-2 font-mono text-2xl leading-tight tracking-[-0.02em] text-foreground"
						style={{ fontWeight: 400 }}
					>
						<span className="text-brand">/</span>unavailable
					</h1>

					<p className="mt-3 text-base leading-[1.55] text-muted-foreground">
						Subscription checkout has been removed. If you were trying to pay
						for a placement, use the advertising flow instead.
					</p>

					<div className="mt-6 space-y-2">
						<button
							type="button"
							onClick={() => navigate({ to: "/" })}
							className="inline-flex w-full min-h-11 items-center justify-center gap-2 bg-brand px-5 font-mono text-sm uppercase tracking-[0.14em] text-background transition-colors hover:bg-brand-hover"
						>
							View advertising options
						</button>

						<button
							type="button"
							onClick={() => navigate({ to: "/dashboard" })}
							className="w-full inline-flex items-center justify-center gap-2 pt-1 font-mono text-sm uppercase tracking-[0.14em] text-muted-foreground transition-colors hover:text-brand"
						>
							<ArrowLeft className="size-3" />
							Back to dashboard
						</button>
					</div>
				</div>
			</main>
		</div>
	);
}
